export const CloverCredentialDefinitionKey = {
    OAUTH: 'oauth',
    OAUTH_GRANT_BINDING: 'oauth_grant_binding',
} as const;

export type CloverCredentialDefinitionKey =
    (typeof CloverCredentialDefinitionKey)[keyof typeof CloverCredentialDefinitionKey];
